import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { broadcastTypePluralTitlesHash } from '@culture/utils/helpers/broadcast';
import BroadcastCard from 'components/cards/BroadcastCard';
import Container from 'components/Container';
import GlobalPromoBlock from 'components/GlobalPromoBlock';
import Layout from 'components/Layout';
import SectionLayout from 'components/SectionLayout';
import SlideSection from 'components/SlideSection';

import ViewsSenderContainer from 'containers/ViewsSender';
import Microdata from 'components/Microdata';

import CommonPropTypes from 'utils/propTypes/common';
import EntitiesPropTypes from 'utils/propTypes/entities';

import BroadcastInformation from './components/BroadcastInformation';
import BroadcastPreview from './components/BroadcastPreview';

const Broadcast = ({
	broadcast,
	microdata,
	breadcrumbs,
	nearestBroadcasts,
	instituteBroadcasts,
	rubric,
	globalPromoBlocks
}) => {
	const promoBlocks = _(globalPromoBlocks).groupBy('placement');

	return (
		<Layout
			meta={broadcast.meta}
			entity={broadcast}
			entityType="broadcast"
			rubricPath={rubric.path}
		>
			<SectionLayout gutter="bottom">
				<BroadcastPreview
					key={broadcast._id}
					data={broadcast}
					breadcrumbs={breadcrumbs}
					theme="entity"
				/>
				<BroadcastInformation broadcast={broadcast} />
				{promoBlocks.middle && (
					<Container>
						<GlobalPromoBlock {...promoBlocks.middle[0]} />
					</Container>
				)}
				{!_.isEmpty(nearestBroadcasts) && broadcast.broadcastType && (
					<SlideSection
						title={broadcastTypePluralTitlesHash[broadcast.broadcastType]}
						items={nearestBroadcasts}
						moreControl={{
							title: `Все ${broadcastTypePluralTitlesHash[
								broadcast.broadcastType
							].toLowerCase()}`,
							url: '/archive/[[...pathParams]]',
							as: `/archive/type-${broadcast.broadcastType}`
						}}
					>
						{_(nearestBroadcasts).map((item) => (
							<BroadcastCard key={item._id} data={item} />
						))}
					</SlideSection>
				)}
				{!_.isEmpty(instituteBroadcasts) && broadcast.institute && (
					<SlideSection
						title="Трансляции в этом месте"
						items={instituteBroadcasts}
						moreControl={{
							title: 'Все трансляции',
							url: '/archive/[[...pathParams]]',
							as: `/archive/institute-${broadcast.institute.sysName}`
						}}
					>
						{_(instituteBroadcasts).map((item) => (
							<BroadcastCard key={item._id} data={item} />
						))}
					</SlideSection>
				)}
				{promoBlocks.bottom && <GlobalPromoBlock {...promoBlocks.bottom[0]} />}
			</SectionLayout>

			<ViewsSenderContainer entityType="movies" entityId={broadcast._id} />
			{microdata && <Microdata>{microdata}</Microdata>}
		</Layout>
	);
};

Broadcast.propTypes = {
	broadcast: EntitiesPropTypes.broadcastItem.isRequired,
	microdata: PropTypes.string,
	breadcrumbs: CommonPropTypes.breadcrumbs.isRequired,
	nearestBroadcasts: EntitiesPropTypes.broadcast,
	instituteBroadcasts: EntitiesPropTypes.broadcast,
	rubric: CommonPropTypes.rubric.isRequired,
	globalPromoBlocks: PropTypes.arrayOf(CommonPropTypes.promoBlock).isRequired
};

Broadcast.defaultProps = {
	nearestBroadcasts: [],
	instituteBroadcasts: []
};

export default Broadcast;
